import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InsertPlanReviewSubmissionTypeMutationVariables = Types.Exact<{
  object: Types.Plan_Review_Submission_Types_Insert_Input;
}>;


export type InsertPlanReviewSubmissionTypeMutation = { __typename?: 'mutation_root', insert_plan_review_submission_types_one?: { __typename?: 'plan_review_submission_types', id: any } | null };


export const InsertPlanReviewSubmissionTypeDocument = gql`
    mutation insertPlanReviewSubmissionType($object: plan_review_submission_types_insert_input!) {
  insert_plan_review_submission_types_one(object: $object) {
    id
  }
}
    `;
export type InsertPlanReviewSubmissionTypeMutationFn = Apollo.MutationFunction<InsertPlanReviewSubmissionTypeMutation, InsertPlanReviewSubmissionTypeMutationVariables>;

/**
 * __useInsertPlanReviewSubmissionTypeMutation__
 *
 * To run a mutation, you first call `useInsertPlanReviewSubmissionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPlanReviewSubmissionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPlanReviewSubmissionTypeMutation, { data, loading, error }] = useInsertPlanReviewSubmissionTypeMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertPlanReviewSubmissionTypeMutation(baseOptions?: Apollo.MutationHookOptions<InsertPlanReviewSubmissionTypeMutation, InsertPlanReviewSubmissionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPlanReviewSubmissionTypeMutation, InsertPlanReviewSubmissionTypeMutationVariables>(InsertPlanReviewSubmissionTypeDocument, options);
      }
export type InsertPlanReviewSubmissionTypeMutationHookResult = ReturnType<typeof useInsertPlanReviewSubmissionTypeMutation>;
export type InsertPlanReviewSubmissionTypeMutationResult = Apollo.MutationResult<InsertPlanReviewSubmissionTypeMutation>;
export type InsertPlanReviewSubmissionTypeMutationOptions = Apollo.BaseMutationOptions<InsertPlanReviewSubmissionTypeMutation, InsertPlanReviewSubmissionTypeMutationVariables>;